import React, { useState } from 'react';
import { Input, Slider } from 'antd';
import { MDBInput } from 'mdb-react-ui-kit';

function IdvComp() {
    // State to track the slider value
    const [sliderValue, setSliderValue] = useState(24298);

    // Handler function to update the slider value
    const handleSliderChange = (value) => {
        setSliderValue(value);
    };

    // Minimum and maximum values from the div elements
    const minIdv = 24298;
    const maxIdv = 52800;

    return (
        <>
            <div className='container'>
                <div className='silderContainer'>
                    <div className='d-flex justify-content-between'>
                        <div className="min-idv">Min IDV</div>
                        <div className="max-idv">Max IDV</div>
                    </div>
                    <Slider defaultValue={sliderValue} onChange={handleSliderChange} className='slider-prices' min={minIdv} max={maxIdv} />
                    <div className='silderContainer-price d-flex justify-content-between'>
                        <div className="">{`₹ ${minIdv}`}</div>
                        <div className="">{`₹ ${maxIdv}`}</div>
                    </div>
                </div>
            </div>
            <div className='underline mt-4'></div>
            <div className='container range-div'>
                <p>
                    Set your own IDV
                </p>
                <MDBInput
                    className='mt-2'
                    value={`₹ ${sliderValue}`}
                    onChange={(e) => {
                        // Update slider value and validate input
                        const newValue = parseInt(e.target.value);
                        if (!isNaN(newValue) && newValue >= minIdv && newValue <= maxIdv) {
                            setSliderValue(newValue);
                        }
                    }}
                    label='Enter your IDV'
                    id='idvInput'
                    type='text'
                />

                <div className=''>
                    <button className='submit-button-filter update-button-edit'>Update</button>
                </div>
            </div>

        </>
    );
}

export default IdvComp;
